import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const TitleSection = styled(Common.TitleSection)``;

export const TitleRow = styled(Common.TitleRow)``;

export const Title = styled(Common.Title)`
	display: inline;
`;

export const RootContainer = styled(Common.RootContainer)``;

export const NotFound = styled(Common.NotFound)``;

export const Popover = styled(Common.Popover)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const BackButton = styled(Common.CircularButton)`
	margin: 0;
`;

export const OrderDetailsContainer = styled(Common.Container)`
	margin: 0rem;
	background-color: #ffffff;
	border: 0.5px solid #eaeaea;
	border-radius: 5px;
`;

export const OrderDetailsHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1rem 2rem 0.5rem;
	font-size: 14px;
	line-height: 14px;
`;

export const OrderId = styled.span`
	margin: 0.75rem 0;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const OrderDate = styled.span`
	margin: 0.5rem 0;
	color: #777777;
`;

export const OrderStats = styled.span`
	margin: 0.5rem 0;
	margin-left: auto;
	color: ${Theme.orange};
	font-weight: bold;
`;

export const TableContainer = styled(Common.TableContainer)`
	height: calc(100vh - 33.3rem) !important;
	min-width: 560px !important;
`;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableColumn = styled(Common.TableColumn)``;

export const ProductImage = styled.img`
	width: 3.5rem;
	height: 3.5rem;
	border-radius: 5px;
	background-color: #fafafa;
	border: 0.5px solid #eaeaea; ;
`;

export const ProductName = styled(Common.FlexRow)`
	padding: 0 0 0 1rem;
`;

export const ProductId = styled(Common.FlexRow)`
	padding: 0.5rem 0 0 1rem;
	font-weight: 500;
	color: #777777;
`;

export const ProductPrice = styled(Common.FlexRow)`
	font-weight: 700;
	color: ${Theme.green};
`;

export const ProductQuantity = styled(Common.FlexRow)``;

export const ProductStatus = styled(Common.FlexRow)`
	color: ${Theme.orange};
	cursor: pointer;
`;

export const PaymentDetailsContainer = styled(Common.Container)`
    margin: 0rem;
    border: 0.5px solid #EAEAEA;
    border-radius: 5px;
    background-color : #FFFFFF;
    line-height: 24px;
    font-size; 16px;
    font-weight: 500;
`;

export const PaymentDetailsHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1rem 2rem 0rem;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const PaymentSummaryContainer = styled(Common.Container)`
	margin: 0.75rem 2rem;
	width: auto;
`;

export const PaymentLine = styled(Common.FlexRow)`
	margin: 0.5rem 0 0 0;
	border: 0px solid #eaeaea;
	border-bottom-width: 1px;
`;

export const PaymentConclusion = styled(Common.FlexRow)`
	margin: 0.5rem 0 0 0;
	color: #ff7004;
`;

export const PaymentKey = styled(Common.FlexColumn)``;

export const PaymentValue = styled(Common.FlexColumn)`
	margin: 0 0 0 auto;
	padding: 4px;
	font-weight: bold;
`;

export const CustomerDetailsContainer = styled(Common.Container)`
	height: calc(100vh - 195px);
	margin: 0rem;
	background-color: #ffffff;
	border: 0.5px solid #eaeaea;
	border-radius: 5px;
`;

export const CustomerDetailsHeader = styled(FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1.75rem 2rem 0rem;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const CustomerSummaryContainer = styled(Common.Container)`
	margin: 1rem 2rem 1rem 2rem;
	diplay: flex;
	flex: 1;
	width: auto;
	overflow: scroll;
`;

export const CustomerImage = styled.div`
	display: flex;
	width: 3.5rem;
	height: 3.5rem;
	margin: 1rem 0;
	background-color: #00ad6f33;
	border: 0.5px solid #eaeaea;
	border-radius: 50%;
	align-self: flex-start;
	& svg {
		align-self: center;
		margin: 0 auto;
		font-size: 30px;
	}
`;

export const CustomerDetailsLine = styled(Common.FlexColumn)`
    width: auto;
    padding: 1rem 0;
    line-height: 28px;
    font-size; 14px;
    border: 0px solid #EAEAEA;
    border-bottom-width: 1px;
`;

export const CustomerDetailsKey = styled(Common.FlexRow)`
	font-weight: bold;
`;

export const CustomerDetailsValue = styled(Common.FlexRow)`
	word-break: break-all;
`;

export const OrderTrackingLink = styled.a`
	font-size: 14px;
	align-items: center;
	color: ${Theme.blue};
	
	& svg {
		font-size: 18px;
		vertical-align: sub;
	}
`;

export const MoreDetails = styled(Common.FlexRow)`
	padding: 1rem 2rem;
	background-color: #fdfcfa;
	border: 1px solid #eaeaea;
	font-size: 16px;
	line-height: 20px;
`;
